import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
  },
  // {
  //   id: ncNanoId(),
  //   href: "/about",
  //   name: "About",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://open.spotify.com/show/79GDG0T0dAJuY9SKRVbIeD",
  //   name: "Spotify",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://podcasts.apple.com/us/podcast/the-moon-crown/id1630683271",
  //   name: "Apple Podcasts",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://pca.st/qnuuufrg",
  //   name: "Pocket Cast",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://www.stitcher.com/show/711932",
  //   name: "Stitcher",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://music.amazon.com/podcasts/f2f3744d-197e-4365-8325-e77d00123091/the-moon-crown",
  //   name: "Amazon Music",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "https://anchor.fm/the-moon-crown",
  //   name: "Anchor",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/contact",
  //   name: "Contact us",
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/blog",
  //   name: "Blog Page",
  //   type: "dropdown",
  //   children: [
  //     {
  //       id: ncNanoId(),
  //       href: "/blog",
  //       name: "Blog Page",
  //     },
  //     {
  //       id: ncNanoId(),
  //       href: "/episode-one",
  //       name: "Blog Single",
  //     },
  //   ],
  // },
];

export const NAVIGATION_DEMO_2: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "#",
    name: "Discover",
    type: "dropdown",
    children: otherPageChildMenus,
  },
];
